import { render, staticRenderFns } from "./ClubsMap.vue?vue&type=template&id=029ebb4c&scoped=true&"
import script from "./ClubsMap.vue?vue&type=script&lang=js&"
export * from "./ClubsMap.vue?vue&type=script&lang=js&"
import style0 from "./ClubsMap.vue?vue&type=style&index=0&id=029ebb4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "029ebb4c",
  null
  
)

export default component.exports